import React, { useEffect, useState } from "react";
import module from "./Footer.module.css";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const [displayQr, setDisplayQr] = useState(false);

  const judgeDisplayQr = () => {
    if (
      location.pathname.includes("/mypage/accounts") ||
      location.pathname.includes("/faq")
    ) {
      setDisplayQr(true);
      return null;
    }
    setDisplayQr(false);
  };

  useEffect(() => {
    judgeDisplayQr();
  }, [location]);

  return (
    <div className={module.wrapFooter}>
      <div className={module.footer}>
        <div>
          <div className={module.footerLogo}>
            <img src={`${process.env.PUBLIC_URL + "/svg/footer_logo.svg"}`} />
          </div>
          <div>
            <a href={`${process.env.PUBLIC_URL}/company`}>会社概要</a>
            <a href={`${process.env.PUBLIC_URL}/agreement`}>利用規約</a>
            <a href={`${process.env.PUBLIC_URL}/contact`}>お問合せ</a>
            <a href={`${process.env.PUBLIC_URL}/faq`}>よくあるご質問</a>
          </div>
        </div>
      </div>
      {displayQr && (
        <div className={module.qr}>
          <span>※QRコードは株式会社デンソーウェーブの登録商標です。</span>
        </div>
      )}
      <div className={module.copyWrite}>
        <div className={module.copyWriteParam}>
          <span>Copyright 2024 nosh©. All Rights Reserved.</span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
